import { publicEnv } from '~/features/environment/public';
import { logger } from '~/features/logging/logger';
import { getUserIdFromJwt } from '~/features/user/utils/get-user-id-from-jwt';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { programRecommendationsSchema } from '../models/program-recommendations';

export async function getProgramRecommendations(jwt: string, limit: number = 10) {
  const userId = getUserIdFromJwt(jwt);

  if (!userId) {
    logger.fatal('User is not authenticated', {
      file: 'src/features/program/controllers/get-program-recommendations.ts',
      function: 'getProgramRecommendations',
      error: {
        userId,
      },
    });

    throw new Error('User is not authenticated');
  }

  return await queryUdacityService({
    method: 'GET',
    url: `${publicEnv.NEXT_PUBLIC_RECOMMENDATIONS_URL}?user=${userId}&limit=${limit}`,
    zodSchema: programRecommendationsSchema,
    authorization: `Bearer ${jwt}`,
  });
}
